<div class="mb-4">
  <h4 class="font-bold">{{ this.title }}</h4>
</div>
<div>
  <div class="innerHtml-cls" [innerHTML]="this.content">
  </div>
</div>

